module.exports = __webpack_public_path__ + "static/media/IconTemplates_-81.100e98e6.svg";